import React, { useContext } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation, withRouter } from 'react-router-dom'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { getLocale } from 'lib/utils/getLocale'

import ContextActionsSelect from 'components/ContextActionsSelect/ContextActionsSelect'
import { AppHeaderContext } from 'components/AppHeader/AppHeader'
import LanguageNavigation from 'components/Navigation/LanguageNavigation/LanguageNavigation'
import Link from 'components/Link'
import AuthLogoutButton from 'components/Auth/AuthLogoutButton/AuthLogoutButton'

import './app-header-user-nav.pcss'

const AppHeaderUserNav = ({ className, renderButton }) => {
    const history = useHistory()
    const location = useLocation()
    const { isAdmin } = useContext(AppHeaderContext)

    const { t, i18n } = useTranslation()

    return (
        <ContextActionsSelect
            renderCustomButton={renderButton}
            cssClass={classNames('app-header-user-nav', className)}
            renderChevron
            chevronProps={{ size: 's' }}
            alignRight
            dataTestId="app-header-user-nav"
        >
            <ul>
                <li>
                    <Link
                        to={`${getLocale(i18n.language)}/kayttaja/muokkaa`}
                        title={t('common:userEditDetails')}
                        trackName="userEditDetails"
                    >
                        {t('common:userEditDetails')}
                    </Link>
                </li>
                <li>
                    <AuthLogoutButton />
                </li>
                <li>
                    <LanguageNavigation history={history} location={location} />
                </li>
                {isAdmin && (
                    <li>
                        <Link
                            exact
                            to={`${getLocale(i18n.language)}/admin`}
                            title="Admin Dashboard"
                            trackName="admin"
                        >
                            Admin Dashboard
                        </Link>
                    </li>
                )}
            </ul>
        </ContextActionsSelect>

    )
}

AppHeaderUserNav.propTypes = {
    className: PropTypes.string.isRequired,
    renderButton: PropTypes.func.isRequired,
}

export default flowRight(
    withErrorBoundaryNoRender,
    withRouter,
)(AppHeaderUserNav)
